/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Wl_Success_TitleInputs */

const en_st_wl_success_title = /** @type {(inputs: St_Wl_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are on the list`)
};

const id_st_wl_success_title = /** @type {(inputs: St_Wl_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu sudah terdaftar`)
};

/**
* | output |
* | --- |
* | "You are on the list" |
*
* @param {St_Wl_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_wl_success_title = /** @type {((inputs?: St_Wl_Success_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Wl_Success_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_wl_success_title(inputs)
	return en_st_wl_success_title(inputs)
});